import { render, staticRenderFns } from "./BankAccountDetailsForm.vue?vue&type=template&id=7b2a4641&"
import script from "./BankAccountDetailsForm.vue?vue&type=script&lang=js&"
export * from "./BankAccountDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports